import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import { DesignationStore } from '@iq-central-front-end/share';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DesignationService {
  constructor(
    private http: HttpClient,
    private designationStore: DesignationStore
  ) { }

  createDesignation(payload) {
    this.designationStore.setLoading(true);
    this.designationStore.clearError();

    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createDesignation}`,
      payload
    ).pipe(
      tap((response) => {
        if (response['responseResult']) {
          this.designationStore.addDesignation(response['responseResult']);
        }
        this.designationStore.setLoading(false);
      }),
      catchError((error) => {
        this.designationStore.setError(error.message || 'An error occurred');
        this.designationStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  getAllDesignations() {
    this.designationStore.setLoading(true);
    this.designationStore.clearError();

    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllDesignations}`
    ).pipe(
      tap((response) => {
        this.designationStore.setDesignations(response['responseResult']);
        this.designationStore.setLoading(false);
      }),
      catchError((error) => {
        this.designationStore.setError(error.message || 'An error occurred');
        this.designationStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  getDesignation(designationId) {
    this.designationStore.setLoading(true);
    this.designationStore.clearError();

    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getOneDesignation}/${designationId}`
    ).pipe(
      tap((response) => {
        this.designationStore.setDesignation(response['responseResult']);
        this.designationStore.setLoading(false);
      }),
      catchError((error) => {
        this.designationStore.setError(error.message || 'An error occurred');
        this.designationStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  deleteDesignation(designationId) {
    this.designationStore.setLoading(true);
    this.designationStore.clearError();

    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteDesignation}/${designationId}`
    ).pipe(
      tap(() => {
        this.designationStore.deleteDesignation(designationId);
        this.designationStore.setLoading(false);
      }),
      catchError((error) => {
        this.designationStore.setError(error.message || 'An error occurred');
        this.designationStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }

  updateDesignation(designationId, payload) {
    this.designationStore.setLoading(true);
    this.designationStore.clearError();

    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateDesignation}/${designationId}`,
      payload
    ).pipe(
      tap((response) => {
        if (response['responseResult']) {
          this.designationStore.updateDesignation(response['responseResult']);
        }
        this.designationStore.setLoading(false);
      }),
      catchError((error) => {
        this.designationStore.setError(error.message || 'An error occurred');
        this.designationStore.setLoading(false);
        return throwError(() => error);
      })
    );
  }
}
